import * as React from 'react';
import type { EditorProps } from '@monaco-editor/react';
import InlineLoader from '../InlineLoader';

const Editor = React.lazy(() => import('@monaco-editor/react'));

export default function CommonEditor(props: EditorProps) {
    return (
        <React.Suspense fallback={<InlineLoader color="multipass" />}>
            <Editor
                {...props}
                defaultLanguage={props.defaultLanguage ?? 'typescript'}
                options={{
                    minimap: { enabled: false },
                    scrollbar: {
                        vertical: 'hidden'
                    },
                    wordWrap: 'on',
                    scrollBeyondLastLine: false,
                    overviewRulerLanes: 0,
                    ...props.options
                }}
            />
        </React.Suspense>
    );
}
